<template>
  <Modal v-on="$listeners">
    <template v-slot:title>Sign in</template>
    <template v-slot:body>
      <Auth @signin="$emit('close')"></Auth>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal'
import Auth from '@/components/Auth'
export default {
  components: {
    Modal,
    Auth
  }
}
</script>
